import { Injectable } from "@angular/core";
import { HttpClientService } from "@/providers/services/http-client.service";
import { IniciarRotasLoteRequest, Rastreio, RastreioApiResponse, RastreioPublicoResponse, TrackingApiResponse } from "@/providers/models/rastreio";
import { PageDatesRequest } from "@/providers/models/pageDatesRequest";

@Injectable({
  providedIn: 'root'
})

export class TrackingService {
  constructor(private httpClient: HttpClientService) { }

  async getRastreios(): Promise<Rastreio[]> {
    return this.httpClient.get('/Rastreio', '');
  }

  async getRastreiosMotorista(userId: number): Promise<Rastreio[]> {
    return this.httpClient.get('/Rastreio', `/motorista/${userId}`);
  }

  async getRastreiosPorDatas(pageDatesRequest: PageDatesRequest): Promise<Rastreio[]> {
    return this.httpClient.post('/Rastreio', `/rastreios/datas`, pageDatesRequest);
  }

  async getRastreiosPorVendedorId(vendedorId: number): Promise<Rastreio[]> {
    return this.httpClient.get('/Rastreio', `/rastreios-vendedor/${vendedorId}`);
  }

  async getRastreiosClientePorNomeClienteOuVendedor(clienteOuVendedor: string): Promise<Rastreio[]> {
    return this.httpClient.get('/Rastreio', `/rastreios/por/nome-cliente-vendedor/${clienteOuVendedor}`);
  }

  async getRastreiosClienteStatus(status: number, motoristaId: number | null): Promise<Rastreio[]> {
    return this.httpClient.get('/Rastreio', `/status/${status}/${motoristaId}`);
  }

  async getRastreiosClientePorNomeVendedor(nomeVendedor: string): Promise<Rastreio[]> {
    return this.httpClient.get('/Rastreio', `/rastreios/por/nome-vendedor/${nomeVendedor}`);
  }

  async getRastreiosPorClienteId(vendedorId: number): Promise<Rastreio[]> {
    return this.httpClient.get('/Rastreio', `/rastreios-cliente/${vendedorId}`);
  }

  async getRastreioPorCodigo(codigo: string): Promise<Rastreio> {
    return this.httpClient.get('/Rastreio', `/codigo/${codigo}`);
  }

  async getRastreioPorNomeCliente(clienteNome: string): Promise<Rastreio> {
    return this.httpClient.get('/Rastreio', `/nome-cliente/${clienteNome}`);
  }

  async getRastreioNomeVendedor(vendedorNome: string): Promise<Rastreio> {
    return this.httpClient.get('/Rastreio', `/vendedor/${vendedorNome}`);
  }

  async getRastreioPorId(rastreioId: number): Promise<Rastreio> {
    return this.httpClient.get('/Rastreio', `/${rastreioId}`);
  }

  async postRastreio(rastreio: Rastreio, usuarioId: number): Promise<Rastreio> {
    return this.httpClient.post('/Rastreio', `/cadastrar-rastreio/${usuarioId}`, rastreio);
  }

  async putRastreio(rastreio: Rastreio, usuarioId: number,): Promise<Rastreio> {
    return this.httpClient.put('/Rastreio', `/atualizar-rastreio/${rastreio.id}/${usuarioId}`, rastreio);
  }

  async deleteRastreio(rastreioId: number, usuarioLogadoId: number): Promise<any> {
    return this.httpClient.delete('/Rastreio', `/id/${rastreioId}/${usuarioLogadoId}`);
  }

  async allListDownload(): Promise<any> {
    return this.httpClient
      .get('/Rastreio', `/rastreios-export`, { responseType: 'blob' });
  }

  async reabrirRastreio(rastreio: Rastreio, status: boolean, usuarioLogadoId: number): Promise<any> {
    return this.httpClient.put('/Rastreio', `/reabrir-rastreio/${rastreio.id}/${status}/${usuarioLogadoId}`, rastreio);
  }


  async finalizarRastreio(rastreio: Rastreio, usuarioLogadoId: number): Promise<any> {
    return this.httpClient.put('/Rastreio', `/finalizar-rastreio-cliente/${rastreio.id}/${usuarioLogadoId}`, rastreio);
  }

  public postImages(rastreioId: number, userLoggedId: number, formData: FormData): Promise<boolean> {
    return this.httpClient.post(`/Rastreio`, `/uploads/${rastreioId}/${userLoggedId}`, formData);
  }

  async postVideo(rastreioId: number, registro: string, usuarioLogadoId: number, file: File): Promise<Rastreio> {
    const fileToUpload = file as File;
    const formData = new FormData();
    formData.append('file', fileToUpload);

    return this.httpClient.post('/Rastreio', `/upload-registro/${rastreioId}/${registro}/${usuarioLogadoId}`, formData);
  }

  public iniciarTransporte(rastreioId: number, motoristaId: number, usuarioNome: string, usuarioId: number): Promise<RastreioApiResponse> {
    return this.httpClient.post(`/Rastreio`, `/iniciar-transporte/${rastreioId}/${motoristaId}/${usuarioNome}/${usuarioId}`, {});
  }

  public iniciarRotasDeEntrega(request: IniciarRotasLoteRequest, usuarioNome: string, usuarioId: number): Promise<RastreioApiResponse> {
    return this.httpClient.post(`/Rastreio`, `/iniciar-entregas/${usuarioNome}/${usuarioId}`, request);
  }

  public concluirRotasDeEntrega(rastreioId: number, usuarioId: number): Promise<RastreioApiResponse> {
    return this.httpClient.post(`/Rastreio`, `/concluir-entrega/${rastreioId}/${usuarioId}`, {});
  }

  public cancelarEntrega(rastreioId: number, motivo: string, usuarioId: number): Promise<RastreioApiResponse> {
    return this.httpClient.post(`/Rastreio`, `/cancelar/entrega/${rastreioId}/${motivo}/${usuarioId}`, {});
  }

  async obterRotaDeEntrega(token: string): Promise<RastreioApiResponse> {
    return this.httpClient.get('/Rastreio', `/rota/${token}`);
  }

  async obterPosicaoMotorista(token: string): Promise<RastreioApiResponse> {
    return this.httpClient.get('/Rastreio', `/rota/posicao/${token}`);
  }

  async buscarEntregasEmAndamento(): Promise<TrackingApiResponse> {
    return this.httpClient.get('/Rastreio', `/entregas-em-andamento`);
  }

  async validateCodeUser(rastreioId: number, code: string): Promise<boolean> {
    return this.httpClient.post("/Rastreio", `/validar-codigo/${rastreioId}/${code}`, "");
  }
}
